import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function AboutSection() {
  return <Section id="despre" background="blush" className="relative overflow-hidden" data-id="element-1">
      {/* Title & subtitle - visible only on mobile, above photo */}
      <div className="md:hidden text-center mb-6" data-id="element-2">
        <h2 className="text-3xl font-bold text-brand-text mb-2" data-id="element-3">
          Daniela Sămărtinean
        </h2>
        <p className="text-brand-primary font-medium text-lg" data-id="element-4">
          Psiholog Clinician & Psihoterapeut Integrativ • Facilitator Legile
          Universale • Mentor
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-10 items-stretch" data-id="element-5">
        {/* Image with decorative elements */}
        <div className="relative flex items-center justify-center" data-id="element-6">
          {/* Decorative dots top-left */}
          <div className="absolute -top-3 left-4 grid grid-cols-4 gap-1.5 z-20" data-id="element-7">
            {[...Array(12)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-brand-primary/30" data-id="element-8" />)}
          </div>

          {/* Decorative dots bottom-right */}
          <div className="absolute -bottom-3 right-4 grid grid-cols-4 gap-1.5 z-20" data-id="element-9">
            {[...Array(12)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-brand-accent/40" data-id="element-10" />)}
          </div>

          {/* Photo container */}
          <div className="relative z-10 w-full h-full min-h-[300px] rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-11">
            <img src="https://cdn.magicpatterns.com/uploads/oKguZ66tL1ePYmfTDvPuKU/WhatsApp_Image_2026-05-04_at_12.09.30.jpg" alt="Daniela Sămărtinean" className="w-full h-full object-cover object-top" data-id="element-12" />

            {/* Accent bar left */}
            <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-16 bg-brand-primary/25 rounded-r-full" data-id="element-13" />

            {/* Accent bar right */}
            <div className="absolute right-0 top-[55%] w-1.5 h-14 bg-brand-accent/30 rounded-l-full" data-id="element-14" />

            {/* Name badge overlay */}
            <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm text-brand-text px-4 py-2.5 rounded-xl shadow-lg border border-brand-primary/10" data-id="element-15">
              <p className="font-bold text-sm text-brand-text" data-id="element-16">
                Daniela Sămărtinean
              </p>
              <div className="flex items-center gap-2 mt-1" data-id="element-17">
                <div className="w-4 h-0.5 bg-brand-primary rounded-full" data-id="element-18" />
                <p className="text-[10px] text-brand-primary font-medium uppercase tracking-wide" data-id="element-19">
                  Psiholog Clinician
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-8" data-id="element-20">
          <div data-id="element-21">
            {/* Title & subtitle - visible only on desktop */}
            <h2 className="hidden md:block text-3xl md:text-4xl font-bold text-brand-text mb-2" data-id="element-22">
              Daniela Sămărtinean
            </h2>
            <p className="hidden md:block text-brand-primary font-medium text-lg mb-6" data-id="element-23">
              Psiholog Clinician & Psihoterapeut Integrativ • Facilitator Legile
              Universale • Mentor
            </p>

            <div className="space-y-6 text-gray-700 leading-relaxed" data-id="element-24">
              <p data-id="element-25">
                Sunt Daniela Sămărinean și lucrez cu oameni de succes
                profesional care, în interior, se confruntă cu anxietate, frici,
                dependențe emoționale sau comportamentale și cu o minte care nu
                se mai oprește din analizat.
              </p>
              <p data-id="element-26">
                Prin metoda mea 3S –{' '}
                <span className="font-semibold text-brand-primary" data-id="element-27">
                  Știință, Suflet și Spirit
                </span>{' '}
                – îi ghidez pe oameni să înțeleagă cauza reală a anxietății și
                fricilor lor, să vindece tiparele moștenite, să-și regăsească
                liniștea minții și puterea interioară.
              </p>
              <p data-id="element-28">
                Integrez Psihologia clinica, Psihoterapia Integrativă, Legile
                Universale și tehnici practice de reconectare cu corpul și cu
                Dumnezeu, pentru a susține vindecarea emoțională profundă și
                transformarea percepțiilor care le-au creat blocajele.
              </p>
            </div>
          </div>

          <div className="bg-white/50 p-6 rounded-xl border border-brand-primary/10" data-id="element-29">
            <h3 className="font-serif text-xl font-bold text-brand-text mb-4" data-id="element-30">
              Misiunea mea
            </h3>
            <ul className="space-y-3" data-id="element-31">
              {['De la frică la claritate', 'De la haos mental la liniște', 'De la deconectare la echilibru interior'].map((item, i) => <li key={i} className="flex items-center text-gray-700" data-id="element-32">
                  <CheckCircle2 className="w-5 h-5 text-brand-accent mr-3 flex-shrink-0" data-id="element-33" />
                  <span data-id="element-34">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}